import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=69df659a&scoped=true"
import script from "./Shares.vue?vue&type=script&lang=js"
export * from "./Shares.vue?vue&type=script&lang=js"
import style0 from "./Shares.vue?vue&type=style&index=0&id=69df659a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69df659a",
  null
  
)

export default component.exports